/** @format */

const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

/**
 * Format an integer cent amount as a USD currency string.
 *   formatCents(1850)   -> "$18.50"
 *   formatCents(123456) -> "$1,234.56"
 *   formatCents("x")    -> "$0.00"
 *
 * Replaces dinero.js for this app: amounts are already integer cents, so the
 * only money operations needed are integer addition (done at the call sites)
 * and display formatting (this helper). No dependency required.
 */
export function formatCents(cents: number): string {
  const n = Number(cents);
  return usd.format((Number.isFinite(n) ? n : 0) / 100);
}

const usdWhole = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Like formatCents, but drops the ".00" on whole-dollar amounts — for inline
 * copy where "$50" reads better than "$50.00" (the shipping selector's
 * eligibility hint, the cart_nudge progress line). Non-whole amounts keep
 * their cents:
 *   formatCentsCompact(5000) -> "$50"
 *   formatCentsCompact(1250) -> "$12.50"
 *   formatCentsCompact("x")  -> "$0"
 */
export function formatCentsCompact(cents: number): string {
  const n = Number(cents);
  const safe = Number.isFinite(n) ? n : 0;
  return safe % 100 === 0 ? usdWhole.format(safe / 100) : usd.format(safe / 100);
}
